import { Pipe, PipeTransform } from '@angular/core';
import { DataFormatService } from "../services/data-format.service";

@Pipe({
    name: 'objectLink',
    standalone: false
})
export class ObjectLinkPipe implements PipeTransform {

  constructor(private dataFormatService: DataFormatService) { }
  transform(value: any): string {
    return this.dataFormatService.formatLink(value);
  }

}
